
<div class="tabs-container">
  
    <mat-tab-group 
        mat-stretch-tabs="true" 
        animationDuration="200ms" 
        class="tabs-group" 
        (selectedTabChange)="onTabChanged($event)">

        <!-- Tab - New user -->
        <mat-tab label={{languageService.Strings.messages.section_newDomain}}>

            <form [formGroup]="formControlGroup" class=global-container>

                <!-- Input - Admin Email -->
                <div class="input_box">
                    <mat-form-field class="input-text noraml-text-size" appearance="fill">
                        <mat-label>
                            {{languageService.Strings.messages.input_box_adminEmail}}
                        </mat-label>
                        <input class="input-test"
                            matInput
                            id="adminEmail"
                            type="email" 
                            placeholder="" 
                            [formControl]="formControl_adminEmail" 
                            [errorStateMatcher]="matcher">
                        <mat-error *ngIf="formControl_adminEmail.hasError('email') ||  
                                        formControl_adminEmail.hasError('spacesInStringValidationError') ||
                                        formControl_adminEmail.hasError('required')" >
                            {{languageService.Strings.errors.format_error_email}}
                        </mat-error>
                    </mat-form-field>
                </div>

                <!-- Input - Notification Email -->
                <div class="input_box">
                    <mat-form-field class="input-text noraml-text-size" appearance="fill">
                        <mat-label>
                            {{languageService.Strings.messages.input_box_notificationEmail}}
                        </mat-label>
                        <input class="input-test"
                            matInput
                            id="notificationEmail"
                            type="email" 
                            placeholder="" 
                            [formControl]="formControl_notificationEmail" 
                            [errorStateMatcher]="matcher">
                        <mat-error *ngIf="formControl_notificationEmail.hasError('email') ||  
                                        formControl_notificationEmail.hasError('spacesInStringValidationError') ||
                                        formControl_notificationEmail.hasError('required')" >
                            {{languageService.Strings.errors.format_error_email}}
                        </mat-error>
                    </mat-form-field>
                </div>

                <!-- Input - Number of days -->
                <div class="input_box">
                    <mat-form-field class="input-text noraml-text-size" appearance="fill">
                        <mat-label>
                            {{languageService.Strings.messages.input_box_nDays}}
                        </mat-label>
                        <input class="input-test"
                            matInput
                            id="nDays"
                            type="number" 
                            placeholder="0" 
                            [formControl]="formControl_nDays" 
                            [errorStateMatcher]="matcher">
                        <mat-error *ngIf="formControl_nDays.hasError('required') ||  
                                        formControl_nDays.hasError('pattern') ||
                                        formControl_nDays.hasError('min')" >
                            {{languageService.Strings.errors.format_error_nDays}}
                        </mat-error>
                    </mat-form-field>
                </div>

                <!-- Button - Mat Menu - Region -->
                <button 
                    mat-raised-button 
                    color="primary" 
                    class="base_buttons button_with_icon"
                    [matMenuTriggerFor]="menuRegion_NewDomain" 
                    >
                        {{languageService.Strings.buttons.button_targetRegion}}: {{optionMenu_Region_value_NewDomain}}
                        <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button> 
                
                <!-- Button - Mat Menu - Language -->
                <button 
                    mat-raised-button 
                    color="primary" 
                    class="base_buttons button_with_icon"
                    [matMenuTriggerFor]="menuLanguageCode_NewDomain" 
                    >
                        {{languageService.Strings.buttons.button_targetLanguage}}: {{optionMenu_LanguageCode_value_NewDomain}}
                        <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button> 

                <!-- Button - Mat Menu - Db Collaborator -->
                <button 
                    mat-raised-button 
                    color="primary" 
                    class="base_buttons button_with_icon"
                    [matMenuTriggerFor]="menuDbCollaborator_NewDomain" 
                    >
                        {{languageService.Strings.buttons.button_dbCollaborator}}: {{getDbCollaborationOptionString(optionMenu_DbCollaborator_value_NewDomain)}}
                        <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button> 

                <!-- Button - Mat Menu - Email and Password Auth -->
                <button 
                    mat-raised-button 
                    color="primary" 
                    class="base_buttons button_with_icon"
                    [matMenuTriggerFor]="menuEmailAndPasswordAuth_NewDomain"
                    >
                        {{languageService.Strings.buttons.button_emailAndPasswordAuth}}: {{getEmailAndPasswordAuthOptionString(optionMenu_EmailAndPasswordAuth_value_NewDomain)}}
                        <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button> 

                <!-- Button - Mat Menu - Password Rotation -->
                <button 
                    mat-raised-button 
                    color="primary" 
                    class="base_buttons button_with_icon"
                    [matMenuTriggerFor]="menuPasswordRotation_NewDomain" 
                    [disabled]="(optionMenu_EmailAndPasswordAuth_value_NewDomain != true)" 
                    >
                        {{languageService.Strings.buttons.button_passwordRotation}}: {{optionMenu_PasswordRotation_value_NewDomain}}
                        <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button>

                <!-- Menu - Region -->
                <mat-menu #menuRegion_NewDomain="matMenu" yPosition="below">
                    <button mat-menu-item *ngFor="let item of optionMenu_Region_OptionList; let i=index"
                    (click)="optionMenuClick_Region_NewDomain(item)" >
                        {{item}}
                    </button>
                </mat-menu>

                <!-- Menu - Language -->
                <mat-menu #menuLanguageCode_NewDomain="matMenu" yPosition="below">
                    <button mat-menu-item *ngFor="let item of optionMenu_LanguageCode_OptionList; let i=index"
                    (click)="optionMenuClick_LanguageCode_NewDomain(item)" >
                        {{item}}
                    </button>
                </mat-menu>

                <!-- Menu - DB Collaborator -->
                <mat-menu #menuDbCollaborator_NewDomain="matMenu" yPosition="below">
                    <button mat-menu-item *ngFor="let item of optionMenu_DbCollaborator_OptionList; let i=index"
                    (click)="optionMenuClick_DbCollaborator_NewDomain(item)" >
                        {{item}}
                    </button>
                </mat-menu>

                <!-- Menu - Email and Password Auth -->
                <mat-menu #menuEmailAndPasswordAuth_NewDomain="matMenu" yPosition="below">
                    <button mat-menu-item *ngFor="let item of optionMenu_EmailAndPasswordAuth_OptionList; let i=index"
                    (click)="optionMenuClick_EmailAndPasswordAuth_NewDomain(item)" >
                        {{item}}
                    </button>
                </mat-menu>

                <!-- Menu - Password Rotation -->
                <mat-menu #menuPasswordRotation_NewDomain="matMenu" yPosition="below">
                    <button mat-menu-item *ngFor="let item of optionMenu_PasswordRotation_OptionList; let i=index"
                    (click)="optionMenuClick_PasswordRotation_NewDomain(item)" >
                        {{item}}
                    </button>
                </mat-menu>

                <!-- Button - Create license -->        
                <button mat-raised-button 
                        color="primary" 
                        class="base_buttons" 
                        (click)="buttonClicked_craeteLicense()" 
                        [disabled]="!formIsValid()"> 
                    {{languageService.Strings.buttons.button_createLicense}}
                </button>
               
            </form>



        </mat-tab>


        <!-- Tab - Existing user -->
        <mat-tab label={{languageService.Strings.messages.section_existingDomains}}>

            <!-- Domain list -->
            <div class=global-container>

                <!-- Button - Mat Menu - Region -->
                <button 
                    mat-raised-button 
                    color="primary" 
                    class="base_buttons button_with_icon"
                    [matMenuTriggerFor]="menuRegion_ExistingDomains" 
                    >
                        {{languageService.Strings.buttons.button_targetRegion}}: {{optionMenue_Region_value_ExistingDomains}}
                        <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button> 

                <!-- Menu - Region -->
                <mat-menu #menuRegion_ExistingDomains="matMenu" yPosition="below">
                    <button mat-menu-item *ngFor="let item of optionMenu_Region_OptionList; let i=index"
                    (click)="optionMenuClick_Region_ExistingDomains(item)" >
                        {{item}}
                    </button>
                </mat-menu>

                <!-- List - Existing domains -->
                <div class="scrollable-list-container" *ngIf="list_ExistingDomains.length > 0">
                    <mat-list role="list">

                        <ng-container *ngFor="let item of list_ExistingDomains; let last = last">
            
                            <mat-list-item role="listitem">
                                <mat-icon matListItemIcon>person</mat-icon>

                                <span matListItemTitle>{{ item }}</span>

                                <div matListItemMeta class="action-buttons">
                                    
                                    <button mat-icon-button color="warn" (click)="buttonClicked_domainSettings(item)">
                                        <mat-icon>settings</mat-icon>
                                    </button>

                                    <button mat-icon-button color="warn" (click)="buttonClicked_deleteDomain(item)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                    
                                </div>
                            </mat-list-item>

                            <mat-divider *ngIf="!last" class="divider"></mat-divider>

                        </ng-container>
                    </mat-list>
                </div>             

            </div>


        </mat-tab>
    
    
    
    
    
    </mat-tab-group>

</div>


<!-- Waiting spinner -->
<div *ngIf="(displayWaitingPopup)" >
    <app-waiting-popup [waitingMessage]="waitingMessage" ></app-waiting-popup> 
</div>
